import { render } from "./MountingPoiRecordView.vue?vue&type=template&id=32e4f96c&scoped=true"
import script from "./MountingPoiRecordView.vue?vue&type=script&lang=js"
export * from "./MountingPoiRecordView.vue?vue&type=script&lang=js"

import "./MountingPoiRecordView.vue?vue&type=style&index=0&id=32e4f96c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32e4f96c"]])

export default __exports__